export const RESPONSE_SUGGESTION_MUTATION_KEY = 'response-suggestion';
